import Swiper, { Navigation, Pagination, Lazy, Autoplay } from "swiper";

Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const sliderMain = document.querySelector(".js-slider-main-swiper");

if (sliderMain) {
    const slides = sliderMain.querySelectorAll(".swiper-slide");

    if (slides && slides.length > 1) {
        new Swiper(sliderMain, {
            rewind: true,
            speed: 300,
            watchSlidesVisibility: true,
            preloadImages: false,
            lazy: {
                elementClass: "lazyload",
                loadPrevNext: true,
                loadPrevNextAmount: 2,
                loadedClass: "swiper-lazyloaded",
                loadingClass: "swiper-lazyloading",
            },
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
                renderFraction: (currentClass, totalClass) => {
                    return `<span class="${currentClass}"> </span> из <span class=" ${totalClass}"> </span>`;
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
}
